/**
 * Display-side privacy guards. The public API already masks scanner emails and strips emails from
 * avatar URLs; these keep the Journey safe even if an older or cached response still carries them.
 */

/** `elio@cafebarbera.com` -> `****@cafebarbera.com` (same form as the server's maskEmail). */
export const maskEmail = (email?: string | null): string => {
  if (!email) return ''
  const at = email.indexOf('@')
  if (at < 0) return '*'.repeat(email.length)
  return '*'.repeat(at) + email.slice(at)
}

const initialsFromEmail = (email: string): string => {
  const local = email.split('@')[0].trim()
  const parts = local.split(/[._+\-\s]+/).filter((p) => /[a-z0-9]/i.test(p))
  if (parts.length >= 2) return `${parts[0][0]} ${parts[1][0]}`.toUpperCase()
  const word = parts[0] ?? local
  if (!word) return ''
  return (word.length >= 2 ? `${word[0]} ${word[1]}` : word[0]).toUpperCase()
}

/** Avatar URL with any email in its `name` parameter replaced by initials (never sent to a third party). */
export const safeAvatarUrl = (url?: string | null): string => {
  if (!url) return ''
  const match = /([?&]name=)([^&#]*)/.exec(url)
  if (!match) return url
  let name = match[2]
  try {
    name = decodeURIComponent(name.replace(/\+/g, ' '))
  } catch {
    // keep the raw value
  }
  if (!name.includes('@')) return url
  const safeName = encodeURIComponent(initialsFromEmail(name)).replace(/%20/g, '+')
  return url.slice(0, match.index) + match[1] + safeName + url.slice(match.index + match[0].length)
}
